import React, { useState } from 'react';
import { FilePlus2, CalendarClock, Sparkles, X } from 'lucide-react';

const STEPS = [
  {
    icon: FilePlus2,
    title: 'Βήμα 1 — Καταχώρησε τον πρώτο σου πελάτη',
    text: 'Πάτησε «Νέα εγγραφή» και πρόσθεσε έναν πελάτη με μια δικάσιμο, αγωγή ή προθεσμία. Παίρνει λιγότερο από ένα λεπτό.',
  },
  {
    icon: CalendarClock,
    title: 'Βήμα 2 — Οι προθεσμίες βγαίνουν μόνες τους',
    text: 'Μόλις καταχωρήσεις τη δικαστική πράξη, το COURTPLAN υπολογίζει αυτόματα όλη την αλυσίδα προθεσμιών — 162 κανόνες για κάθε διαδικασία.',
  },
  {
    icon: Sparkles,
    title: 'Βήμα 3 — Οργάνωσε τη μέρα σου',
    text: 'Στο «Πρόγραμμα ημέρας» βλέπεις δικασίμους, ραντεβού και εργασίες. Ο AI Organiser κατανέμει τις εκκρεμότητες στις επόμενες ημέρες με ένα κλικ.',
  },
];

export const OnboardingGuide = ({ userId, onClose, onStart }) => {
  const [step, setStep] = useState(0);
  const markDone = () => {
    try { localStorage.setItem(`cp_onboarding_done_${userId}`, '1'); } catch (_) {}
  };
  const finish = () => { markDone(); onClose(); };
  const start = () => { markDone(); onClose(); if (onStart) onStart(); };
  const s = STEPS[step];
  const Icon = s.icon;
  return (
    <div className="fixed inset-0 z-[70] flex items-end sm:items-center justify-center bg-slate-900/40 p-4" data-testid="onboarding-guide">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-2xl border border-slate-200 p-6 relative">
        <button onClick={finish} data-testid="onboarding-skip-x" title="Παράλειψη"
          className="absolute top-3 right-3 w-7 h-7 flex items-center justify-center text-slate-400 hover:text-slate-700">
          <X className="w-4 h-4" />
        </button>
        {step === 0 && (
          <p className="text-xs font-bold text-red-700 tracking-wide mb-2">Καλώς ήρθες στο COURTPLAN</p>
        )}
        <div className="w-12 h-12 rounded-xl bg-red-700/10 text-red-700 flex items-center justify-center mb-3">
          <Icon className="w-6 h-6" />
        </div>
        <h3 className="text-base font-semibold text-slate-900 mb-1.5" data-testid="onboarding-step-title">{s.title}</h3>
        <p className="text-sm text-slate-600 mb-5" style={{ lineHeight: 1.55 }}>{s.text}</p>
        <div className="flex items-center gap-1.5 mb-5">
          {STEPS.map((_, i) => (
            <span key={i} className={`h-1.5 rounded-full transition-all ${i === step ? 'w-6 bg-red-700' : 'w-1.5 bg-slate-300'}`} />
          ))}
        </div>
        <div className="flex items-center justify-between">
          <button onClick={finish} data-testid="onboarding-skip-btn" className="text-sm text-slate-500 hover:text-slate-800">
            Παράλειψη
          </button>
          {step < STEPS.length - 1 ? (
            <button onClick={() => setStep(step + 1)} data-testid="onboarding-next-btn"
              className="h-10 px-5 rounded-lg bg-red-700 text-white text-sm font-semibold hover:bg-red-800">
              Επόμενο
            </button>
          ) : (
            <button onClick={start} data-testid="onboarding-finish-btn"
              className="h-10 px-5 rounded-lg bg-red-700 text-white text-sm font-semibold hover:bg-red-800">
              Ξεκινάω! Έχω 100 δωρεάν μονάδες
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default OnboardingGuide;
